var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayProgress)?_c('div',{attrs:{"id":"loadingScreen"}},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',[_c('div',{staticClass:"row"},[_c('h2',{staticStyle:{"color":"#ffffff"}},[_vm._v("Please wait...")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"loadersmall"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-144a8d3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/ProgressHUD/ProgressHUD.component.html
// module id = G+1Y
// module chunks = 1